/**
 * Indica se o erro é de requisição abortada (AbortController / axios cancel).
 * @param {unknown} error
 */
export function isAbortedListRequest(error) {
  return error?.name === "AbortError" || error?.code === "ERR_CANCELED";
}
